import React from 'react';
import SEO from '../seo';
import styled from 'styled-components';
import Project from '../Project';
const ProjectContainer = styled.div``;

const ProjectHeader = styled.p``;
const Projects = () => {
  return (
    <ProjectContainer>
      <SEO title="Projects" />
      <ProjectHeader>
        I am always working on projects and these are some projects I am proud of.
      </ProjectHeader>


      <Project
        title="Shaadi Dapp"
        link="https://github.com/SOLTOTHEMOON/Wedding-Chain"
        linktext="github.com/SOLTOTHEMOON/Wedding-Chain"
        info="Collaborated and developed a decentralized marriage registry web-app using Solana and Arweave for Building Out Loud Hackathon"
        tech={['React', 'Blockchain', 'Solana', 'Arweave', 'Web3.js']}
      />
      <Project
        title="Mission Covid Suraksha"
        link="https://www.ramaiah-apps.com/"
        linktext="www.ramaiah-apps.com"
        info='Designed, developed and deployed a survey web-app for MS Ramaiah Clinical Research Centre using MERN stack and REST API. 
        It features authentication, filtration of large data and auto-database backup.'
        tech={['React', 'Express', 'MongoDB', 'NodeJS', 'SemanticUI']}
      />

      <Project
        title="Career Portal - IDC"
        link="https://www.careerportalreport.com"
        linktext="www.careerportalreport.com"
        info="Developed website for displaying reports of career portals state-wise during my internship in the company."
        tech={['HTML5', 'CSS3', 'JS', 'ChartsJS', 'D3JS', 'GeoJSON']}
      />
      <Project
        title="Protech Engineering"
        link="https://www.protechengineering.in"
        linktext="www.protechengineering.in"
        info="Designed and developed responsive PWA website for company’s official porfolio"
        tech={['React', 'SASS', 'Bootstrap', 'MaterialUI']}
      />

    </ProjectContainer>
  );
};

export default Projects;
